<template>
    <button v-if="visibility" class="btn_l" 
            :class="{ 'opacity-50 cursor-not-allowed': isProcessing }"
            :style="{fontSize: font_size + 'px', backgroundColor: color, padding: padding}" 
            :disabled="isProcessing || disabled"
            @click.stop="handleClick">
      <div v-if="isProcessing" class="flex items-center justify-center gap-1">
        <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ loadingText || text || 'Carregando...' }}
      </div>
      <div v-else class="flex items-center justify-center gap-1">
        <i v-if="left_icon" :class="left_icon"></i>
        {{ text?text:'' }}
        <i v-if="right_icon" :class="right_icon" @click.stop="handleRightIconClick"></i>
      </div>
    </button>
  </template>
  
  <script>
  export default {
    name: 'AppButton',
    props: {
      text: {
        type: String,
        
      },
      loadingText: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: 'transparent'
      },
      emitType: {
        type: String,
        required: true
      },
      left_icon: {
        type: String,
        default: null
      },
      right_icon: {
        type: String,
        default: null
      },
      width: {
        type: Number,
        default: 106 // default width in pixels
      },
      height: {
        type: Number,
        default: 42 // default height in pixels
      },
      font_size: {
        type: Number,
        default: 14 // default font size in pixels
      },
      padding: {
        type: String,
        default: '0.5rem 0.8rem'
      },
      visibility: {
        type: Boolean,
        default: () => false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      preventDoubleClick: {
        type: Boolean,
        default: true
      },
      cooldownMs: {
        type: Number,
        default: 1000
      }
    },
    emits:['create','select', 'update','delete', 'back', 'close','list', 'loading' ],
    data() {
      return {
        isProcessing: false
      }
    },
    methods: {
      async handleClick() {
        if (this.isProcessing && this.preventDoubleClick) return
        
        if (this.preventDoubleClick) {
          this.isProcessing = true
          this.$emit('loading', true)
          
          // Auto-reset after cooldown
          setTimeout(() => {
            this.isProcessing = false
            this.$emit('loading', false)
          }, this.cooldownMs)
        }
        
        this.emitEvent()
      },
      handleRightIconClick() {
        if (this.isProcessing && this.preventDoubleClick) return
        console.log("right icon clicked");
        this.$emit('close');
      },
      emitEvent() {
        switch (this.emitType) {
          case 'create':
            this.$emit('create');
            break;
          case 'select':
            this.$emit('select');
            break;
          case 'update':
            this.$emit('update');
            break;
          case 'delete':
            this.$emit('delete');
            break;
          case 'back':
            this.$emit('back');
            break;
          case 'close':
            this.$emit('close');
            break;
          case 'list':
            this.$emit('list');
            break;
          default:
            console.log("no emit")
        }
      },
      // Public method to reset loading state
      resetLoading() {
        this.isProcessing = false
        this.$emit('loading', false)
      }
    }
  };
  </script>
  
  <style scoped>
      @import url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter&family=Montserrat:wght@600&family=Poppins:wght@600&display=swap');

    .btn_l {
        width: fit-content;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 8px;
        background-color: var(--button);
        color: var(--iconCima);
        border: none;
        border-radius: 10px;
        padding: 0.2rem 0.6rem;
        cursor: pointer;
        gap: 0.1rem;
        text-wrap: nowrap;
    }
  </style>
  